export default __webpack_public_path__ + "static/assets/5c84f7bfff441e3864a2266d1e86d530.png";